export const BASE_URL_API: string | undefined = 'https://app.wubmal.com/api/';
export const BASE_URL_APP = 'https://app.wubmal.com';
export const ONE_MB_IN_BYTES: number = 1048576;
export const earthRadius = 6371;
export const defaultPriceMin = 0;
export const defaultPriceMax = 1000000;
export const defaultDistanceMin = 0;
export const defaultDistanceMax = 100;
